<div ngModelGroup="comboGrauParentesco-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboGrauParentesco
                       nome="grauParentesco-{{data}}"
                       [itens]="dados"
                       itemDescricao="nome"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Grau de parentesco"
                       [label]="label"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
